module.exports = __webpack_public_path__ + "f43f8f5b39f581b483eb0d69b723c3a8.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/ic-minimum-purchase.png
// module id = 3154
// module chunks = 0